<template>

  <el-row v-loading="isLoading">
    <el-col :xs="24" :md="24" class="arvore-competencias-card">
      <el-card style="margin-left: 1em"  v-if="periodo" >
        <div slot="header">
          <span class="cadastro-title">Periodo : {{ periodo.ano }}</span>
        </div>

        <el-form>
          <el-form-item label="Status" prop="status">
            <el-switch v-model="periodo.status"
                       :active-value="1"
                       :inactive-value="0"></el-switch>
          </el-form-item>

          <el-row>
            <el-col :md="12">
              <el-col :md="12">
                <ul class="list-group">
                  <li class="list-group-item"
                      v-for="competencia in periodo.competencias.slice(0,periodo.competencias.length/2 + 1)">
                              <span style="font-weight: bold">
                               {{competencia.ano}} - {{ competencia.mes}}
                              </span>
                    <el-switch class="pull-right"
                               v-model="competencia.visivel"
                               active-color="#13ce66"
                               inactive-color="#ff4949"
                               :active-value="1"
                               :inactive-value="0">
                    </el-switch>
                  </li>
                </ul>
              </el-col>
              <el-col :md="12">
                <ul class="list-group">
                  <li class="list-group-item"
                      v-for="competencia in periodo.competencias.slice(periodo.competencias.length/2 + 1,100)">
                        <span style="font-weight: bold">
                         {{competencia.ano}} - {{ competencia.mes}}
                        </span>
                    <el-switch class="pull-right"
                               v-model="competencia.visivel"
                               active-color="#13ce66"
                               inactive-color="#ff4949"
                               :active-value="1"
                               :inactive-value="0">
                    </el-switch>
                  </li>
                </ul>
              </el-col>
            </el-col>
            <el-col :md="12">
              <el-form-item>
                <el-tree
                  ref="listTree"
                  :data="listTree"
                  show-checkbox
                  node-key="id"
                  allIds
                  default-expand-all
                  :default-checked-keys="centroCustoIds"
                  :props="defaultProps">
                </el-tree>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button type="danger" size="mini" class="pull-left" @click="excluir()">Excluir</el-button>
              <el-button type="primary" class="pull-right" @click="salvar()">Salvar</el-button>
              <el-button type="warning" class="pull-right" @click="listar()">Lista</el-button>
            </el-col>
          </el-row>
        </el-form>

      </el-card>
    </el-col>

  </el-row>


</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {trataErrors} from "../../domain/utils";

  export default {
    name: "Edit",
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'nome'
        },
        isLoading: false,
        periodo: null
      }
    },
    computed: {
      ...mapGetters('CentroCusto', ['listTree']),
      centroCustoIds() {
        return _.map(this.periodo.centro_custos, 'id')
      },
      competenciasVisiveis() {
        if (!this.periodo) {
          return []
        }
        const visiveis = collect(this.periodo.competencias)
        return visiveis.where('visivel', 1).pluck('id').all()
      }
    },
    methods: {
      ...mapActions('CentroCusto', ['setList']),
      async salvar() {
        try {
          this.isLoading = true
          const request = {status: null, competencias: [], centros: []}
          request.id = this.periodo.id
          request.status = this.periodo.status
          request.centros = this.$refs.listTree.getCheckedKeys()
          request.competencias = this.competenciasVisiveis
          const {data} = await axios.put(`${process.env.API_PATH}/periodo/${request.id}`, {...request})
          this.$notify.success({
            title: 'Atualização',
            message: 'Registro atualizado com sucesso!'
          });
          this.isLoading = false

        } catch (error) {
          console.log(error)
          trataErrors(error)
        }
      },
      listar() {
        this.$router.push({'name': 'periodo.index'})
      },
      async excluir() {
        try {
          await this.$confirm('Isso excluirá o registro permanentemente. Deseja Continuar?', 'Cuidado!', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })

          const id = this.periodo.id
          const {data} = await axios.delete(`${process.env.API_PATH}/periodo/${this.periodo.id}`)

          this.$notify.success({
            title: 'Exclusão',
            message: 'Registro excluido com sucesso!'
          });
          this.$router.push({'name': 'periodo.index'})
        } catch (e) {
          return true
        }
      }
    },
    async mounted() {
      try {
        this.isLoading = true
        const resPeriodo = axios.get(`${process.env.API_PATH}/periodo/${this.$route.params.periodo}`)
        const [periodoResp, centroResp] = await Promise.all([resPeriodo, this.setList()])
        this.periodo = periodoResp.data

      } catch (error) {
      } finally {
        this.isLoading = false
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Periodo/Show.vue